/**
 * @generated SignedSource<<637cd7b69b1bb55b3871822fe34845e5>>
 * @relayHash 1e0f9b2b3ec256270767f3f3ac941855
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1e0f9b2b3ec256270767f3f3ac941855

import { ConcreteRequest } from 'relay-runtime';
export type CreateSubscriptionCheckoutLinkInput = {
  cancelUrl: any;
  referralIntentId?: string | null;
  successUrl: any;
};
export type useContraProStripeCheckoutCreateSubscriptionCheckoutLinkMutation$variables = {
  input: CreateSubscriptionCheckoutLinkInput;
};
export type useContraProStripeCheckoutCreateSubscriptionCheckoutLinkMutation$data = {
  readonly createSubscriptionCheckoutLink: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
    readonly url: string | null;
  };
};
export type useContraProStripeCheckoutCreateSubscriptionCheckoutLinkMutation = {
  response: useContraProStripeCheckoutCreateSubscriptionCheckoutLinkMutation$data;
  variables: useContraProStripeCheckoutCreateSubscriptionCheckoutLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useContraProStripeCheckoutCreateSubscriptionCheckoutLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSubscriptionCheckoutLinkPayload",
        "kind": "LinkedField",
        "name": "createSubscriptionCheckoutLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContraProStripeCheckoutCreateSubscriptionCheckoutLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateSubscriptionCheckoutLinkPayload",
        "kind": "LinkedField",
        "name": "createSubscriptionCheckoutLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "1e0f9b2b3ec256270767f3f3ac941855",
    "metadata": {},
    "name": "useContraProStripeCheckoutCreateSubscriptionCheckoutLinkMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ff8fe2aa04597e95b0828d8017e93736";

export default node;
